/* @flow */

export const ACTION = {
  FETCH_SHIFTS_LOADING: 'FETCH_SHIFTS_LOADING',
  FETCH_SHIFTS_SUCCESS: 'FETCH_SHIFTS_SUCCESS',
  FETCH_SHIFTS_FAIL: 'FETCH_SHIFTS_FAIL',

  FETCH_EMPLOYEES_LOADING: 'FETCH_EMPLOYEES_LOADING',
  FETCH_EMPLOYEES_SUCCESS: 'FETCH_EMPLOYEES_SUCCESS',
  FETCH_EMPLOYEES_FAIL: 'FETCH_EMPLOYEES_FAIL',
};

export const DATE_FORMATS = {
  APP_FORMAT: 'YYYY-MM-DD',
  PREVIEW_FORMAT: 'MMM D',
};

export const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];



// WEBPACK FOOTER //
// ./src/constants/index.js